import React, { Component, Fragment } from 'react';
import logo from './logo.svg';
import PBNViewerControlCont from "./containers/PBNViewerControlCont"
import {Grid, LinearProgress, Paper, PropTypes} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles';
import InfoMessageCont from "./containers/InfoMessage";
import PBNViewerContentCont from "./containers/PBNViewerContentCont";

const style = theme => ({
    '@global': {
        '*': {
            boxSizing:'border-box',
            margin:0,
            padding:0
        },
        'html, body, #root': {
            height: '100%',

        }
    },
    topPaper: {
        padding:5,
        margin:5
    },
    centralPaper: {
        padding:5,
        margin:5,
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            minHeight: '580px'
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: '360px'
        }
    },
    container: {
        height: '100%',
        minHeight: '0px'
    },
    auctionContainer: {
        [theme.breakpoints.down('sm')]: {
            height: '40%',
        },
        [theme.breakpoints.up('sm')]: {
            height: '100%',
        },
        minHeight: '0px'
    },
    playContainer: {
        [theme.breakpoints.down('sm')]: {
            height: '60%',
        },
        [theme.breakpoints.up('sm')]: {
            height: '100%',
        },
        minHeight: '0px'
    }

});

class App extends Component {
    render() {
        const {classes} = this.props;

        /*return (
            <div style={{display:'flex', flexDirection:'column', height:'100%', minHeight:'0px'}} >
                <div item>
                    <Paper style={{width:'100%'}}>
                        TEST 1
                    </Paper>
                </div>

                <div style={{display:'flex', flexDirection:'column', height:'100%', minHeight:'0px'}}>
                    <div style={{display:'flex', flexDirection:'row', height:'100%', minHeight:'0px'}}>
                        <Paper style={{overflow:'auto', width:'25%', height:'100%', minHeight:'0px'}}>
                                    {[1,2,3,4,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,1,2,3,4,6,7,8, 9, 10].map(i => (
                                            <div>TEST {i} </div>
                                        )
                                    )}
                        </Paper>
                        <Paper style={{display:'flex', alignSelf:'stretch', flexDirection:'column'}}>
                        </Paper>
                    </div>
                </div>
            </div>
        );*/

        return (
            <Fragment>
                <Grid container className={classes.container} wrap={"nowrap"} direction={"column"} spacing={0}>
                    <Grid item >
                        <PBNViewerControlCont/>
                    </Grid>
                    <Grid item container className={classes.container} direction={"column"}>
                        <Paper className={classes.centralPaper} >
                            <PBNViewerContentCont/>
                        </Paper>
                    </Grid>
                </Grid>
                <InfoMessageCont/>
            </Fragment>
        );
    }
}

export default withStyles(style)(App);
